import { render, staticRenderFns } from "./AccordionContent.vue?vue&type=template&id=1ccc8d6a"
import script from "./AccordionContent.vue?vue&type=script&lang=js"
export * from "./AccordionContent.vue?vue&type=script&lang=js"
import style0 from "./AccordionContent.vue?vue&type=style&index=0&id=1ccc8d6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports